import { FC, SyntheticEvent } from 'react';
import Icon, { IconIds } from 'src/common/components/IconDS22';
import UniversalLink from 'src/common/components/UniversalLink';
import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import styles from './OwnerNavigationItem.module.scss';

type AdminNavigationItemProps = {
  href: string;
  active: boolean;
  showWarning?: boolean;
  icon: IconIds;
  onClick?: (e: SyntheticEvent) => void;
  children: React.ReactNode;
};

const AdminNavigationItem: FC<AdminNavigationItemProps> = ({
  href,
  active,
  icon,
  showWarning,
  onClick,
  children,
}) => (
  <li className={styles.root}>
    <UniversalLink
      href={href}
      className={getClassNames(
        styles,
        'link',
        classNames({
          active,
          showWarning,
        }),
      )}
      onClick={onClick}
    >
      <span className={styles.linkContent}>
        <Icon
          id={icon}
          size="l"
          className={styles.icons}
        />
        {children}
      </span>
      {showWarning && <Icon id="warning-filled" className={styles.warningIcon} />}
    </UniversalLink>
  </li>
);

export default AdminNavigationItem;
